import { LocalizedPack } from 'apollo/localizedTypes';
import getMissingLanguages from 'utils/i18n/getMissingLanguages';
import translatableRichText from 'utils/i18n/translatableRichText';

const dataToTable = (data: LocalizedPack[] | undefined) => {
  if (!data) return [];
  const mappedPacks = data?.map((pack, index) => {
    const {
      name,
      description,
      adultValue,
      otherValue,
      status,
      activities,
      entranceTicketTypes,
      packImages,
      visibility,
    } = pack;
    return {
      key: index,
      name: name.es,
      missingTranslations: getMissingLanguages([
        name,
        ...translatableRichText(description),
      ]),
      adultValue,
      otherValue,
      status,
      activities,
      entranceTicketTypes,
      packImages,
      visibility,
      actions: pack,
    };
  });
  return mappedPacks;
};

export default dataToTable;
